import React from 'react'

import type { CallToActionBlock as CTABlockProps } from '@/payload-types'

import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'
import { cn } from '@/utilities/ui'
import { ChevronsRight } from 'lucide-react'

export const CallToActionBlock: React.FC<CTABlockProps> = ({ links, richText, description }) => {
  const alignMentClass = 'flex-col items-center text-center'

  return (
    <section
      className={cn('relative border-border border  bg-background not-prose')}
      aria-label="Call to action"
      style={{
        clipPath: 'ellipse(75% 100% at top)',
        backgroundColor: 'var(--primary)',
        border: 'none',
        height: 'auto',
        // minHeight: '370px',
      }}
    >
      <div
        className={cn(
          'container mx-auto 2xl:px-0 flex flex-col md:flex-row md:justify-start md:items-center relative z-10 pb-8 md:pb-0',
        )}
      >
        <div className={cn('flex flex-1 flex-col items-center text-center justify-between h-full gap-y-2')}>
          {/* Heading for accessibility and structure */}
          {richText && (
            <div className="text-3xl mt-5 md:text-4xl lg:text-5xl font-bold text-primary-foreground leading-snug">
              <RichText
                data={richText}
                enableGutter={false}
                enableProse={false}
                resetChildMargins
                style={{ fontFamily: 'var(--font-sans)' }}
              />
            </div>
          )}
          {description && (
            <div className="prose prose-base max-w-none text-primary-foreground leading-relaxed">
              <RichText
                data={description}
                enableGutter={false}
                enableProse={false}
                resetChildMargins
                style={{ fontFamily: 'var(--font-sans)' }}
              />
            </div>
          )}
          <div className="flex-grow" />
          {links && links.length > 0 && (
            <nav aria-label="Call to action links" className="mb-8 mt-auto w-full">
              <ul className="flex flex-col md:flex-row gap-4 md:gap-8 justify-center">
                {links.map(({ link }, i) => (
                  <li key={i}>
                    <div className="relative overflow-hidden group rounded-full inline-flex">
                      <CMSLink
                        {...link}
                        key={i}
                        className="z-10 inline-flex items-center border border-secondary text-secondary bg-secondary-foreground hover:bg-secondary/90 cursor-pointer font-semibold text-base tracking-wide transition-colors duration-300 rounded-full px-6 py-8"
                        aria-label={link.label || 'Learn more about this service'}
                      >
                        <div className="w-12 h-12 rounded-full flex flex-1 items-center justify-center ml-2 bg-secondary text-secondary-foreground">
                          <ChevronsRight />
                        </div>
                      </CMSLink>
                    </div>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </div>
      </div>
    </section>
  )
}
